export default "__VITE_ASSET__a41dfc0d__"